const sectionStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "60px 20px"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "20px",
  background: "#fff",
  boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
  transition: "all 0.2s ease"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 15px 35px rgba(0,0,0,0.1)"
    : "0 10px 25px rgba(0,0,0,0.05)";
  e.currentTarget.style.transform = enter
    ? "translateY(-3px)"
    : "translateY(0)";
};

const AwsSolutionsArchitectProfessional = () => {
  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>
          Designing Complex, Production-Ready Cloud Architectures
        </h1>

        <p style={{ fontSize: "18px", color: "#555", maxWidth: "700px" }}>
          With the AWS Certified Solutions Architect – Professional certification, I design end-to-end
          cloud systems that balance scalability, performance, cost, and security — based on real-world constraints.
        </p>
      </div>


      {/* IMAGE */}
      <div style={{ ...sectionStyle, paddingTop: "0", textAlign: "center" }}>
        <img
          src="/images/awsSolutionsArchitectProfessionalBadge.png"
          alt="AWS Certified Solutions Architect Professional"
          style={{
            width: "100%",
            maxWidth: "280px",
            borderRadius: "12px",
            boxShadow: "0 15px 40px rgba(0,0,0,0.15)"
          }}
        />

        <div style={{ fontSize: "14px", color: "#777", marginTop: "10px" }}>
          AWS Certified Solutions Architect – Professional
        </div>
      </div>


      {/* INTRO */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          This certification represents advanced expertise in designing distributed systems on AWS —
          where every architectural decision involves trade-offs.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          It goes beyond individual services and focuses on building complete systems that are scalable,
          resilient, cost-efficient, and aligned with business goals.
        </p>
      </div>


      {/* CAPABILITIES 🔥 */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>
          Architecture Capabilities I Can Deliver
        </h2>

        <div style={gridStyle}>
          {[
            "Designing end-to-end cloud architectures across multiple AWS services",
            "Building highly scalable and fault-tolerant distributed systems",
            "Performing trade-off analysis between performance, cost, and complexity",
            "Designing multi-region and high-availability architectures",
            "Integrating serverless, containerized, and traditional workloads",
            "Designing event-driven and decoupled system architectures",
            "Optimizing architectures for cost efficiency and resource usage",
            "Designing hybrid and multi-environment systems",
            "Ensuring security and compliance across the architecture"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              ✓ {item}
            </div>
          ))}
        </div>
      </div>


      {/* ARCHITECTURE THINKING 🔥 */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "25px" }}>
          Architecture Is About Trade-Offs
        </h2>

        <div style={gridStyle}>
          {[
            "Performance vs cost optimization",
            "Scalability vs operational complexity",
            "Consistency vs availability (distributed systems)",
            "Speed of delivery vs long-term maintainability",
            "Managed services vs custom solutions",
            "Simplicity vs flexibility in system design"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* USE CASES 🔥 */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>
          Where This Creates Real Value
        </h2>

        <div style={gridStyle}>
          {[
            "Designing new cloud-native systems from scratch",
            "Modernizing legacy applications into scalable architectures",
            "Optimizing existing systems for cost and performance",
            "Building high-traffic and high-availability applications",
            "Designing systems for global scale and distribution",
            "Aligning technical architecture with business requirements"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* POSITIONING */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          Architecture is not about using the most services — it’s about making the right decisions
          for a specific problem.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          I focus on designing systems that work reliably in production, scale with demand,
          and remain maintainable over time.
        </p>
      </div>


      {/* CTA 🔥 */}
      <div style={{
        textAlign: "center",
        margin: "80px 0",
        padding: "50px 20px",
        background: "#fafafa"
      }}>
        <h2 style={{ marginBottom: "15px" }}>
          Design Your Cloud Architecture the Right Way
        </h2>

        <p style={{ color: "#555", marginBottom: "25px" }}>
          Let’s design a system that is scalable, efficient, and aligned with your business goals.
        </p>

        <a
          href="/contact"
          style={{
            display: "inline-block",
            padding: "14px 32px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
          }}
        >
          Discuss Your Architecture →
        </a>
      </div>

    </div>
  );
};

export default AwsSolutionsArchitectProfessional;